import React, { useContext, useEffect, useState } from "react";
import Account from "../../Services/accountServices";
import { NavLink } from "react-router-dom";
import { Button } from "primereact/button";
import USDFigure from "../../Components/USDFigure";
import AFNFigure from "../../Components/AFNFigure";
import Icons from "../../Components/Icons";
import { AuthContext } from "../../Auth/Context/AuthContext";
import TitleHeader from "./Components/TitleHeader";
import { Spin } from "antd";
function AccountsList(props) {
  const { user } = useContext(AuthContext);
  const [accounts, setAccounts] = useState([]);
  const [accountsCopy, setAccountsCopy] = useState([]);
  const [searchedValue, setSearchedValue] = useState();
  const [loading, setLoading] = useState(false);
  const fetchAllAccounts = async () => {
    setLoading(true);
    await Account.getExpandingAccounts(user.branchId).then((acc) => {
      setAccounts(acc.data);
      setAccountsCopy(acc.data);
      setLoading(false);
    });
  };
  useEffect(() => {
    fetchAllAccounts();
  }, []);
  const filterAccount = async () => {
    setLoading(true);
    await Account.filterAccount(searchedValue)
      .then((response) => {
        setLoading(false);
        setAccounts(response.data);
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error in filtering account", error);
      });
  };

  const filterLocalAccounts = (value) => {
    setSearchedValue(value);
    if (value === "") {
      setAccounts(accountsCopy);
    } else {
      const filteredAccounts = accountsCopy.filter((op) =>
        op.name.toLowerCase().includes(value.toLowerCase())
      );
      setAccounts(filteredAccounts);
    }
  };

  const [expandedAccounts, setExpandedAccounts] = useState([]);
  const [isAllExpanded, setIsAllExpanded] = useState(false);
  const toggleAllRows = () => {
    if (isAllExpanded) {
      setExpandedAccounts([]);
    } else {
      const allAccountIds = accounts?.map((acc) => acc.id);
      setExpandedAccounts(allAccountIds);
    }
    setIsAllExpanded(!isAllExpanded);
  };
  const toggleAccount = (accountId) => {
    if (expandedAccounts.includes(accountId)) {
      setExpandedAccounts(expandedAccounts.filter((id) => id !== accountId));
    } else {
      setExpandedAccounts([...expandedAccounts, accountId]);
    }
  };
  const renderAccounts = (accounts, level = 0) => {
    return accounts?.map((acc) => (
      <>
        <tr>
          <td style={{ paddingLeft: level * 20 }}>
            <a key={acc.id} onClick={() => toggleAccount(acc.id)}>
              {acc.subAccountArray?.length > 0 && (
                <i
                  class={
                    expandedAccounts.includes(acc.id)
                      ? "ion-arrow-down-b"
                      : "ion-arrow-right-b"
                  }
                ></i>
              )}
            </a>
            &nbsp;&nbsp;
            <NavLink to={`/account-quick-report/${acc.id}`}>
              {acc?.code}-{acc.name} ({acc.generalAccountCategory})
            </NavLink>
          </td>
          <td>
            {acc.balance > 0 ? (
              <p style={{ color: "green" }}>
                {acc.currencyName === "USD" ? (
                  <USDFigure amount={acc.balance} />
                ) : (
                  <AFNFigure amount={acc.balance} />
                )}
              </p>
            ) : (
              <p style={{ color: "red" }}>
                {acc.currencyName === "USD" ? (
                  <USDFigure amount={acc.balance} />
                ) : (
                  <AFNFigure amount={acc.balance} />
                )}
              </p>
            )}
          </td>
          <td>
            {acc.balanceTotal > 0 ? (
              <p style={{ color: "green" }}>
                {acc.currencyName === "USD" ? (
                  <USDFigure amount={acc.balanceTotal} />
                ) : (
                  <AFNFigure amount={acc.balanceTotal} />
                )}
              </p>
            ) : (
              <p style={{ color: "red" }}>
                {acc.currencyName === "USD" ? (
                  <USDFigure amount={acc.balanceTotal} />
                ) : (
                  <AFNFigure amount={acc.balanceTotal} />
                )}
              </p>
            )}
          </td>
        </tr>
        {expandedAccounts.includes(acc.id) &&
          acc.subAccountArray?.map((sub) => (
            <>
              <tr key={sub.id}>
                <td style={{ paddingLeft: (level + 1) * 20 }}>
                  {sub.subAccountArray?.length > 0 && (
                    <i
                      class={
                        expandedAccounts.includes(sub.id)
                          ? "ion-arrow-down-b"
                          : "ion-arrow-right-b"
                      }
                    ></i>
                  )}
                  &nbsp;&nbsp;
                  <NavLink to={`/account-quick-report/${sub.id}`}>
                    {sub?.code}-{sub.name} ({sub.generalAccountCategory})
                  </NavLink>
                </td>
                <td>
                  {sub.balance > 0 ? (
                    <p style={{ color: "green" }}>
                      <USDFigure amount={sub.balance} />
                    </p>
                  ) : (
                    <p style={{ color: "red" }}>
                      <USDFigure amount={sub.balance} />
                    </p>
                  )}
                </td>
                <td>
                  {sub.balanceTotal > 0 ? (
                    <p style={{ color: "green" }}>
                      <USDFigure amount={sub.balanceTotal} />
                    </p>
                  ) : (
                    <p style={{ color: "red" }}>
                      <USDFigure amount={sub.balanceTotal} />
                    </p>
                  )}
                </td>
              </tr>
              {sub.subAccountArray &&
                renderAccounts(sub.subAccountArray, level + 2)}
            </>
          ))}
      </>
    ));
  };
  return (
    <>
      <div class="page-wrapper">
        <div class="content container-fluid">
          <TitleHeader title={`Charts of Account-(${accounts.length})`} />
          <div class="row">
            <Button
              icon="pi pi-plus"
              label={isAllExpanded ? "Collapse All" : "Expand All"}
              onClick={toggleAllRows}
              text
            />
            <div class="col-sm-12">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive">
                    <div class="form-group d-flex">
                      <input
                        type="text"
                        name="search"
                        placeholder="Type account name you want . . ."
                        onChange={(e) => filterLocalAccounts(e.target.value)}
                      />
                      <a onClick={filterAccount}>
                        <Icons name="ion-ios7-search-strong" />
                      </a>
                      <a onClick={fetchAllAccounts}>
                        <Icons name="ion-ios7-loop-strong" />
                      </a>
                    </div>
                    {loading && (
                      <div className="text-center">
                        <Spin />
                      </div>
                    )}
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Account</th>
                          <th>Balance</th>
                          <th>Balance Total</th>
                        </tr>
                      </thead>
                      <tbody>{renderAccounts(accounts)}</tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AccountsList;
